import TableCard from "@components_v2/card/table-card";
import AssetThumbnail from "@features/thumbnail/asset-thumbnail";
import { Grid, Typography } from "@mzc-pdc/ui";
import convertToByte from "@cores/convertToByte";
import StatusBadge from "@components_v2/status-badge/status-badge";
import formatDuration from "@cores/formatDuration";
import CollectionThumbnail from "@features/thumbnail/collection-thumbnail";
import AssetTypeFlag from "@components_v2/icon-type/asset/asset-type-flag";
import ContentTypeFlag from "@components_v2/icon-type/content/content-type-flag";
import { ASSET_PREVIEW_STATUS, MEDIA_TYPES } from "@constants";
import BadgeCollection from "@components_v2/badge-collection/badge-collection";
import MediaImageWrapper from "@routes/asset/components/media-image-wrapper";
import { alpha } from "@mui/material";
import ContentMediaImage from "@features/content-media-image/content-media-image";
import React from "react";

export const getTableValueByAssetColumn = (columnId, option) => {
    switch (columnId) {
        case "desiredStatus":
            return (
                <Grid container justifyContent={"center"}>
                    <StatusBadge status={option?.status} />
                </Grid>
            );
        case "name": {
            let src;

            const commonStatusPreviews = option?.previews?.filter((p) => p.status !== ASSET_PREVIEW_STATUS.ERROR);
            const previewStatus =
                commonStatusPreviews?.length === 0 && option.previews?.length > 0
                    ? ASSET_PREVIEW_STATUS.ERROR
                    : commonStatusPreviews?.[0]?.status ?? ASSET_PREVIEW_STATUS.COMPLETE;

            if (commonStatusPreviews?.[0]?.accessUrl) src = commonStatusPreviews?.[0]?.accessUrl;
            if (!src) {
                if (option?.mediaType === MEDIA_TYPES.IMAGE) {
                    src = option.accessUrls?.[0] ?? option.elements?.[0]?.accessUrl;
                } else if (option.mediaType === MEDIA_TYPES.VIDEO) src = option.thumbnails?.[0]?.accessUrl;
            }
            return (
                <TableCard
                    thumbnail={
                        <AssetThumbnail
                            variant={"table"}
                            src={src}
                            width={52}
                            height={52}
                            asset={option}
                            errorIconProps={{ position: "left", size: 16 }}
                            previewStatus={previewStatus}
                        />
                    }
                    name={{
                        name: (
                            <Typography variant={"body1_500"} component={"span"}>
                                {option?.name ?? "-"}
                            </Typography>
                        ),
                        startIcon: <AssetTypeFlag size={"small"} type={option.mediaType} />,
                    }}
                    subName={{
                        name: !option?.mediaType ? null : `.${option?.extensions ?? "-"} `,
                    }}
                />
            );
        }
        case "type":
            return <Grid item>{option?.mediaType ?? "-"}</Grid>;
        case "extensions":
            return <Grid item>{option?.extensions ? `.${option?.extensions}` : "-"}</Grid>;
        case "size":
            return <Grid item>{option?.size ? convertToByte(option?.size) : "-"}</Grid>;
        case "duration":
            return <Grid item>{option?.duration ? formatDuration(option?.duration) : null}</Grid>;
        default:
            return option?.[columnId];
    }
};

export const getTableValueByContentColumn = (columnId, option) => {
    switch (columnId) {
        case "desiredStatus":
            return (
                <Grid container justifyContent={"center"}>
                    <StatusBadge status={option?.status?.toUpperCase()} />
                </Grid>
            );
        case "name": {
            return (
                <TableCard
                    thumbnail={
                        <MediaImageWrapper
                            sx={{
                                position: `relative`,
                                width: 52,
                                height: 52,
                                borderRadius: `4px`,
                                backgroundColor: alpha("#e5e7ed", 0.5),
                                overflow: `hidden`,
                            }}
                        >
                            <ContentMediaImage
                                contentType={option.contentType}
                                variant={"table"}
                                size={"small"}
                                errorIconProps={{ position: "left", size: 16 }}
                                data={option}
                                draggable={false}
                                isShowImagePreviewModal={false}
                            />
                        </MediaImageWrapper>
                    }
                    name={{
                        name: (
                            <Typography variant={"body1"} component={"span"}>
                                {option?.name}
                            </Typography>
                        ),
                        startIcon: <ContentTypeFlag size={"small"} type={option.contentType} />,
                    }}
                />
            );
        }
        case "type":
            return <Grid item>{option?.mediaType}</Grid>;
        case "size":
            return <Grid item>{option?.size ? convertToByte(option?.size) : "-"}</Grid>;
        case "duration":
            return <Grid item>{formatDuration(option?.duration)}</Grid>;
        default:
            return option?.[columnId];
    }
};

export const getTableValueByCollectionColumn = (columnId, option) => {
    if (columnId === "name")
        return (
            <TableCard
                thumbnail={<CollectionThumbnail collection={option} size={"small"} variant={"table"} />}
                name={{
                    name: (
                        <Typography variant={"body1_500"} component={"span"}>
                            {option?.name}
                        </Typography>
                    ),
                }}
            />
        );
    if (columnId === "count")
        return (
            <Grid item>
                <BadgeCollection totalCount={option?.assetTotalCount} />
            </Grid>
        );
    return null;
};
